module.exports = __webpack_public_path__ + "img/campana-black.2af8e576.png";